import React, { useEffect, useState } from "react"
import { apiAuthorizate } from "./Actions";
import { useDispatch } from "react-redux";
import { USER_FETCH_SUCCESS, USER_RESET } from "../../reducers/user";
import { useLocation, useNavigate } from "react-router-dom";
import {CLEAR_MENU, SET_MENU} from "../../reducers/navigation";
import {EnigooLoader} from "../../components/My/EnigooLoader";


const Auth = () => {

    let dispatch = useDispatch()
    const location = useLocation();
    const navigation = useNavigate();

    const getRoute = (data) => {
        if (location.pathname === "/" || location.pathname === "/login") {
            navigation("/dashboard");
        }
    }

    useEffect(() => {
        authorizate()
    }, [])

    const authorizate = () => {
        apiAuthorizate(data => {
            dispatch({ type: USER_FETCH_SUCCESS, payload: data });
            dispatch({ type: CLEAR_MENU});
            dispatch({ type: SET_MENU, rights: data?.rights });

            getRoute(data)
        }, () => {
            localStorage.removeItem('authorization-turn-enigoo')
            dispatch({ type: USER_RESET })

        })
    }

    //return <Loader isDone={done} />

    return <EnigooLoader/>
}
export default Auth
